import * as types from "./actionTypes";
import API from "../../services/ProductService";
import {apiCallError, beginApiCall} from "./apiStatusActions";

export function loadProductsSuccess(products) {
  return { type: types.LOAD_PRODUCTS_SUCCESS, products };
}

export function createProductSuccess(product) {
  return { type: types.CREATE_PRODUCT_SUCCESS, product };
}

export function updateProductSuccess(product) {
  return { type: types.UPDATE_PRODUCT_SUCCESS, product };
}

export function saveProduct(product) {
  return (dispatch) => {
    dispatch(beginApiCall('saveProduct'));
    return API.saveProduct(product)
      .then((savedProduct) => {
        dispatch(product.id ? updateProductSuccess(savedProduct) : createProductSuccess(savedProduct));
        return savedProduct;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadProducts() {
  return (dispatch) => {
    dispatch(beginApiCall('getProducts'));
    return API.getProducts()
      .then((products) => {
        dispatch(loadProductsSuccess(products));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
